import React from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'

type Props = {
  show: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
}

const ProfileNotesModal: React.FC<Props> = ({show, title, onClose, children}) => {
  return (
    <Modal show={show} onHide={onClose} size='xl' centered scrollable>
      <Modal.Header className='py-3'>
        <Modal.Title className='fw-bold'>{title}</Modal.Title>
        <button
          type='button'
          className='btn btn-icon btn-sm btn-active-light-primary ms-2'
          onClick={onClose}
          aria-label='Close'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
        </button>
      </Modal.Header>
      <Modal.Body>{show ? children : null}</Modal.Body>
      <Modal.Footer className='py-3'>
        <button type='button' className='btn btn-sm btn-light' onClick={onClose}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ProfileNotesModal
